// extracted by mini-css-extract-plugin
export default {"main":"index_main_qpv-G"};